import React, { useState, useEffect, useCallback } from 'react'
import GoogleMapReact from 'google-map-react'
import Loading from 'custom/assets/loaders/Loading'
import Config from 'custom/config/environment'
import NeoInput from '../../../components/NeoInput/NeoInput'
import FooterServices from '../../../services/footer.service'
import { useHistory } from 'react-router-dom'
import AuthLayout from '../auth-layout'
import { LANDING_BRANCH_KEYS, BUTTON_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function Location() {
  const { t } = useTranslation()
  const history = useHistory()
  const [locations, setLocations] = useState({})
  const [zoom, setZoom] = useState(3)
  const [isLoading, setLoading] = useState(false)
  const [mapCenter, setMapCenter] = useState(Config.COORDINATES)
  const [tabList, setTabList] = useState([])
  const [selectedTab, setSelectedTab] = useState('')
  const [noRecords, setNoRecords] = useState(false)
  const Marker = () => (
    <div>
      <img
        src='https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi.png'
        alt='boohoo'
        className='img-responsive'
      />
    </div>
  )
  const locationNameCallback = useCallback(
    (e) => {
      const selected = locations[selectedTab].filter(
        (ele) => ele.locationName === e.target.value,
      )[0]
      setMapCenter({
        lat: parseFloat(selected?.latitude),
        lng: parseFloat(selected?.longitude),
      })
      setZoom(15)
    },
    [locations, selectedTab],
  )

  useEffect(() => {
    setMapCenter(Config.COORDINATES)
    setZoom(5)
  }, [selectedTab])

  const getLocations = useCallback(async () => {
    try {
      setLoading(true)
      const response = await FooterServices.getLocations({ locationType: 'ALL' })
      if (response.status === 200) {
        setLoading(false)
        setNoRecords(response.data.length > 0 ? false : true)
        if (response.data) {
          const locationDetails = response.data.reduce(function (location, obj) {
            ;(location[obj['locationType']] = location[obj['locationType']] || []).push(obj)
            return location
          }, {})
          if (Object.keys(locationDetails).length > 0) {
            setSelectedTab(Object.keys(locationDetails)[0])
            setTabList(Object.keys(locationDetails))
            setLocations(locationDetails)
          }
        }
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getLocations()
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <AuthLayout>
      <div className='mt-5'>
        <div className='new-design-form-style'>
          {isLoading && renderLoading()}

          {noRecords && (
            <span className='noRecords-text-style'>{t(LANDING_BRANCH_KEYS.LOCATION_NO_INFO)}</span>
          )}

          {tabList.length > 0 && (
            <div className='row tab-navbar'>
              {tabList.map((tab, index) => (
                <div key={index} className={tab === selectedTab ? `col-${12 / tabList.length} selected` : `col-${12 / tabList.length}`}>
                  <span onClick={() => setSelectedTab(tab)}>{tab}</span>
                </div>
              ))}
            </div>
          )}

          {Object.keys(locations).length > 0 && (
            <>
              <div className='form-group text-dark'>
                <NeoInput
                  tabIndex='1'
                  mode='native-select'
                  onChange={locationNameCallback}
                  text={t(LANDING_BRANCH_KEYS.CHOOSE_OPTION)}
                  list={locations[selectedTab] || []}
                  keyValue={'locationName'}
                />
              </div>

              <div className='my-5' style={{ height: '50vh', width: '100%' }}>
                <GoogleMapReact
                  tabIndex={'2'}
                  bootstrapURLKeys={{ key: Config.GOOGLE_MAP_API_KEY }}
                  center={mapCenter}
                  defaultZoom={13}
                  zoom={zoom}>
                  {locations[selectedTab].map((value, i) => (
                    <Marker key={i} lat={value.latitude} lng={value.longitude} />
                  ))}
                </GoogleMapReact>
              </div>
            </>
          )}

          {(tabList.length > 0 || noRecords) && (
            <div className='row text-center d-flex justify-content-center my-5 mb-1'>
              <button
                tabIndex={'3'}
                onClick={() =>
                  history.push({
                    pathname: '/landing',
                  })
                }
                className='btn btn-sm btn-link small new-design-warning-text-color font-weight-600'>
                {t(BUTTON_KEYS.BACK)}
              </button>
            </div>
          )}
        </div>
      </div>
    </AuthLayout>
  )
}
